/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: f7EdRjw-ChvD
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicSectionFooter.module.css"; // plasmic-import: f7EdRjw-ChvD/css

createPlasmicElementProxy;

export const PlasmicSectionFooter__VariantProps = new Array("layout");

export const PlasmicSectionFooter__ArgProps = new Array("sectionId");

const $$ = {};

function PlasmicSectionFooter__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layout",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layout
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <section
      data-plasmic-name={"footer"}
      data-plasmic-override={overrides.footer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.footer,
        {
          [sty.footerlayout_full]: hasVariant($state, "layout", "full"),
          [sty.footerlayout_withOffset]: hasVariant(
            $state,
            "layout",
            "withOffset"
          )
        }
      )}
      id={(() => {
        try {
          return $props.sectionId;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"contentWrapper"}
        data-plasmic-override={overrides.contentWrapper}
        className={classNames(projectcss.all, sty.contentWrapper, {
          [sty.contentWrapperlayout_full]: hasVariant($state, "layout", "full")
        })}
      >
        <div
          data-plasmic-name={"leftColumn"}
          data-plasmic-override={overrides.leftColumn}
          className={classNames(projectcss.all, sty.leftColumn, {
            [sty.leftColumnlayout_full]: hasVariant($state, "layout", "full")
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__jGBxD, {
              [sty.freeBoxlayout_full__jGBxDoi57P]: hasVariant(
                $state,
                "layout",
                "full"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__qcPEs,
                {
                  [sty.textlayout_full__qcPEsOi57P]: hasVariant(
                    $state,
                    "layout",
                    "full"
                  )
                }
              )}
            >
              {"COMPANY."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__t8Cek,
                {
                  [sty.textlayout_full__t8CekOi57P]: hasVariant(
                    $state,
                    "layout",
                    "full"
                  )
                }
              )}
            >
              {"OP for my practice."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__dUJyO,
                {
                  [sty.textlayout_withOffset__dUJyOu2Elz]: hasVariant(
                    $state,
                    "layout",
                    "withOffset"
                  )
                }
              )}
            >
              {
                "\u00a92025 OP for my practice. All rights reserved.\nBuilt and backed by haaaven SRL."
              }
            </div>
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__uevdU, {
              [sty.freeBoxlayout_full__uevdUoi57P]: hasVariant(
                $state,
                "layout",
                "full"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__hg1QH
              )}
            >
              {"WEBSITES."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__cfEmY
              )}
            >
              <React.Fragment>
                <React.Fragment>{"OP [ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link___5VrbM,
                      {
                        [sty.linklayout_full___5VrbMoi57P]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://partner.opformypractice.com/"}
                    platform={"react"}
                  >
                    {"partner"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__cr192
              )}
            >
              <React.Fragment>
                <React.Fragment>{"OP [ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link___52Kjs,
                      {
                        [sty.linklayout_full___52KjsOi57P]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://team.opformypractice.com/"}
                    platform={"react"}
                  >
                    {"team"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__rnIh
              )}
            >
              <React.Fragment>
                <React.Fragment>{"OP [ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__nxLIx,
                      {
                        [sty.linklayout_full__nxLIxOi57P]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://nexus.opformypractice.com/"}
                    platform={"react"}
                  >
                    {"nexus"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"rightColumn"}
          data-plasmic-override={overrides.rightColumn}
          className={classNames(projectcss.all, sty.rightColumn)}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__bdfk, {
              [sty.freeBoxlayout_full__bdfkOi57P]: hasVariant(
                $state,
                "layout",
                "full"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__pzkVy
              )}
            >
              {"GO TO."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__cPgcb
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__qXo19
                    )}
                    href={`/login`}
                    platform={"react"}
                  >
                    {"login"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__xMbuU
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__virZm
                    )}
                    href={`/signup`}
                    platform={"react"}
                  >
                    {"signup"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__fH0Zl
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__dEhza
                    )}
                    href={"https://opformypractice.com/legal"}
                    platform={"react"}
                  >
                    {"legal"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__dnk7C)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__rmAcz
              )}
            >
              {"CONTACT."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__hxIyl
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__u9Csw
                    )}
                    href={`/support`}
                    platform={"react"}
                  >
                    {"support"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__eGU
              )}
            >
              {"ask@opformypractice"}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const PlasmicDescendants = {
  footer: ["footer", "contentWrapper", "leftColumn", "rightColumn"],
  contentWrapper: ["contentWrapper", "leftColumn", "rightColumn"],
  leftColumn: ["leftColumn"],
  rightColumn: ["rightColumn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionFooter__ArgProps,
          internalVariantPropNames: PlasmicSectionFooter__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionFooter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footer") {
    func.displayName = "PlasmicSectionFooter";
  } else {
    func.displayName = `PlasmicSectionFooter.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionFooter = Object.assign(
  // Top-level PlasmicSectionFooter renders the root element
  makeNodeComponent("footer"),
  {
    // Helper components rendering sub-elements
    contentWrapper: makeNodeComponent("contentWrapper"),
    leftColumn: makeNodeComponent("leftColumn"),
    rightColumn: makeNodeComponent("rightColumn"),
    // Metadata about props expected for PlasmicSectionFooter
    internalVariantProps: PlasmicSectionFooter__VariantProps,
    internalArgProps: PlasmicSectionFooter__ArgProps
  }
);

export default PlasmicSectionFooter;
/* prettier-ignore-end */
